import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import LanguageContext from "../../i18n/LanguageContext";

class AboutV3 extends Component {
  render() {
    const { t } = this.context;
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__about-us-area pt-115 pb-100 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <div className="about-us-img-wrap about-img-left">
                <img
                  src={publicUrl + "assets/img/5.png"}
                  alt="About Us Image"
                />
                <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3 d-none">
                  <div className="ltn__video-img ltn__animation-pulse1">
                    <img
                      src={publicUrl + "assets/img/5.png"}
                      alt="video popup bg image"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 align-self-center">
              <div className="about-us-info-wrap">
                <div className="section-title-area ltn__section-title-2--- mb-30">
                  <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                    {t("homeAbout.subtitle")}
                  </h6>
                  <h1 className="section-title">{t("homeAbout.title")}</h1>
                  <p>{t("homeAbout.intro")}</p>
                </div>
                <div className="ltn__feature-item ltn__feature-item-3">
                  <div className="ltn__feature-icon">
                    <span>
                      <i className="flaticon-house-4" />
                    </span>
                  </div>
                  <div className="ltn__feature-info">
                    <h4>
                      <a>{t("homeAbout.f1Title")}</a>
                    </h4>
                    <p>{t("homeAbout.f1Text")}</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-3">
                  <div className="ltn__feature-icon">
                    <span>
                      <i className="flaticon-call-center-agent" />
                    </span>
                  </div>
                  <div className="ltn__feature-info">
                    <h4>
                      <a>{t("homeAbout.f2Title")}</a>
                    </h4>
                    <p>{t("homeAbout.f2Text")}</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-3">
                  <div className="ltn__feature-icon">
                    <span>
                      <i className="flaticon-maps-and-location" />
                    </span>
                  </div>
                  <div className="ltn__feature-info">
                    <h4>
                      <a>{t("homeAbout.f3Title")}</a>
                    </h4>
                    <p>{t("homeAbout.f3Text")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AboutV3.contextType = LanguageContext;

export default AboutV3;
